module.exports = __webpack_public_path__ + "img/driver-avatar.35606a9b.png";